/* see https://github.com/sealninja/react-grid-system for default values. */
const defaultConfig = {
  /*
  Breakpoints can be found in the include-media.scss
  $breakpoints: (
    'phone': 568px,
    'tablet': 768px,
    'laptop': 1024px,
    'desktop': 1366px,
  ) !default;
  */
  breakpoints: [568, 768, 1024, 1366],
  /*
  Max container width for desktop is 1200 based on design.
  The rest is bootstrap defaults.
  */
  containerWidths: [540, 750, 960, 1200],
  gutterWidth: 10,
  gridColumns: 12,
};

export const calendarConfig = {
  ...defaultConfig,
  gridColumns: 7,
  gutterWidth: 0,
};

export default defaultConfig;
